import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { FreudButtonModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { PromptuaryQualityDescriptionModule } from '../promptuary-quality-description/promptuary-quality-description.module';
import { PromptuaryTaskDescriptionModule } from '../promptuary-task-description/promptuary-task-description.module';
import { ServiceEvolutionQualityBannerModule } from '../service-evolution-quality-banner/service-evolution-quality-banner.module';
import { PromptuaryRegisterModalComponent } from './promptuary-register-modal.component';

@NgModule({
	declarations: [PromptuaryRegisterModalComponent],
	exports: [PromptuaryRegisterModalComponent],
	providers: [],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FormsModule,
		FreudTypographyModule,
		FreudButtonModule,
		PromptuaryQualityDescriptionModule,
		ServiceEvolutionQualityBannerModule,
		PromptuaryTaskDescriptionModule,
	],
})
export class PromptuaryRegisterModalComponentModule {}
